module.exports = __webpack_public_path__ + "static/media/removeIcon.f6e9d514.svg";